import { storage_keys } from '@/constant/configs';
import { i18n } from '@/i18n-config';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';

export default function useRestaurantLocale() {
  const [restaurantLang, setRestaurantLang] = useState<string>(
    i18n.defaultLanguage
  );

  useEffect(() => {
    const locale = Cookies.get(storage_keys.restaurant_lang);
    if (locale) {
      setRestaurantLang(locale);
    }
  }, []);

  return {
    restaurantLang,
  };
}
